import { FileJson, Download, Loader2, X } from "lucide-react";
import { BACKEND_URL } from "@/lib/api";
import { ImageDropzone } from "@/components/common/ImageDropzone";

export function BulkSelectStep({ files, setFiles, metaFile, setMetaFile, onStart, progress }) {
  const totalMb = (files.reduce((s, f) => s + f.size, 0) / 1024 / 1024).toFixed(1);
  const busy = progress !== null;
  return (
    <div className="grid gap-8 lg:grid-cols-12" data-testid="bulk-select-step">
      <div className="space-y-4 lg:col-span-8">
        <ImageDropzone multiple onFiles={(fs) => setFiles((prev) => [...prev, ...fs])} testid="bulk-upload-dropzone"
          label="Drop all card images for your set" hint="PNG, JPG or WebP · hundreds of files supported · include back-face images too" />
        {files.length > 0 && (
          <div className="panel flex items-center justify-between p-4 text-sm" data-testid="bulk-selected-summary">
            <span className="text-slate-300"><strong className="text-amber-200">{files.length}</strong> images selected · {totalMb} MB</span>
            <button className="btn-ghost" onClick={() => setFiles([])} disabled={busy} data-testid="bulk-clear-files"><X className="h-4 w-4" />Clear</button>
          </div>
        )}
      </div>
      <div className="space-y-5 lg:col-span-4">
        <div className="panel p-5">
          <p className="eyebrow mb-3">Optional metadata</p>
          <p className="mb-4 text-sm text-slate-400">
            Add a CSV or JSON file to pre-fill names, costs, types, abilities, rarity, set codes and back faces. Rows are matched to images by
            <code className="mx-1 rounded bg-black/40 px-1 font-mono text-xs text-amber-200">image_filename</code>.
          </p>
          <label className="btn-outline w-full cursor-pointer" data-testid="bulk-metadata-label">
            <FileJson className="h-4 w-4" />{metaFile ? metaFile.name : "Choose CSV / JSON"}
            <input type="file" accept=".csv,.json,text/csv,application/json" className="hidden" data-testid="bulk-metadata-input"
              onChange={(e) => setMetaFile(e.target.files?.[0] || null)} />
          </label>
          {metaFile && <button className="btn-ghost mt-2 w-full text-xs" onClick={() => setMetaFile(null)} data-testid="bulk-metadata-remove">Remove metadata file</button>}
          <a href={`${BACKEND_URL}/api/v1/uploads/metadata-template.csv`} className="btn-ghost mt-2 w-full text-xs" data-testid="bulk-template-download">
            <Download className="h-3.5 w-3.5" />Download CSV template
          </a>
        </div>
        <button className="btn-gold w-full" disabled={!files.length || busy} onClick={onStart} data-testid="bulk-start-button">
          {busy ? <><Loader2 className="h-4 w-4 animate-spin" />Uploading {progress.done}/{progress.total}</> : "Upload & review"}
        </button>
        {busy && (
          <div className="h-1.5 overflow-hidden rounded-full bg-[#2A3447]" role="progressbar" aria-valuenow={progress.done} aria-valuemax={progress.total}>
            <div className="h-full bg-amber-500 transition-[width] duration-300" style={{ width: `${(progress.done / progress.total) * 100}%` }} />
          </div>
        )}
      </div>
    </div>
  );
}
